<div class="rounded-4 bg-white border p-3 attribute-card d-flex flex-column">
  <div class="d-flex mb-3 align-items-center flex-wrap">
    <h3 class="fs-24 mb-0 me-2">{{ attribute()?.name }}</h3>
    @if (attributeValuesDisplay()!.length > 0) {
      <div class="position-relative ms-auto me-2">
        <svg-icon
          [name]="'search-topbar'"
          class="position-absolute top-50 start-0 translate-middle-y ms-3 svg-20"
        ></svg-icon>
        <input class="form-control ps-5 py-2 rounded-5" type="text" placeholder="Search" [(ngModel)]="search" />
      </div>
    }
  </div>
  @if (attributeValuesDisplay()!.length > 0) {
    <div class="flex-fill overflow-y-auto pe-2 pb-3">
      <div class="d-flex flex-column gap-2">
        <div class="d-flex align-items-center gap-2 mb-1">
          <div class="d-flex align-items-center gap-3">
            <div class="form-check form-control-sm mb-0">
              <input
                class="form-check-input"
                type="checkbox"
                id="select-all"
                [checked]="!!isAllValuesSelected()"
                (click)="toggleSelectionAll()"
              />
              <label class="form-check-label" for="flexCheckDefault"> Select All</label>
            </div>
            <div class="form-check form-control-sm mb-0">
              <input
                class="form-check-input"
                type="checkbox"
                [checked]="isShowSelected()"
                (click)="isShowSelected.set(!isShowSelected())"
              />
              <label class="form-check-label" for="flexCheckDefault"> Show Selected</label>
            </div>
          </div>
        </div>
        @for (attributeValue of attributeValuesDisplay()?.slice(0, toggleAttributeValues()); track $index) {
          <div class="rounded-3 px-2 py-1 border d-flex align-items-center">
            <div class="form-check form-control-sm">
              <input
                class="form-check-input"
                type="checkbox"
                [checked]="attributeValue.isSelected"
                (click)="$event.stopPropagation(); assignValues.emit([attributeValue])"
              />
            </div>
            <p class="mb-0 fs-14">{{ attributeValue?.value }}</p>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="flex-fill">
      <div class="bg-gray-200 rounded-3 p-3 h-100">
        <div class="d-flex align-items-center justify-content-center flex-column h-100">
          <p class="mb-2">No Attribute Values</p>
        </div>
      </div>
    </div>
  }
  @if ((attributeValuesDisplay()?.length || 0) > 10) {
    <div
      class="pt-3 border-top border-gray-300 fs-14"
      role="button"
      (click)="
        toggleAttributeValues() === 10
          ? toggleAttributeValues.set(attributeValuesDisplay()?.length || 0)
          : toggleAttributeValues.set(10)
      "
    >
      <p class="text-center mb-0">
        <i class="bi bi-chevron-down me-1"></i>Show
        {{ toggleAttributeValues() > 10 ? 'Less' : (attributeValuesDisplay()?.length || 0) - 10 + ' More' }}
      </p>
    </div>
  }
</div>
